// images can be swapped to local assets as needed
import one from "../images/backgrounds/1_result.webp";
import two from "../images/backgrounds/2_result.webp";
import three from "../images/backgrounds/3_result.webp";
import four from "../images/backgrounds/4_result.webp";
import five from "../images/backgrounds/5_result.webp";
import six from "../images/backgrounds/6_result.webp";
import seven from "../images/backgrounds/7_result.webp";
import aath from "../images/backgrounds/8_result.webp";
import nine from "../images/backgrounds/9_result.webp";
import ten from "../images/backgrounds/Retail_result.webp";
import elevan from "../images/backgrounds/Construction_result.webp";
import twelve from "../images/backgrounds/Sports_result.webp";
import thirteen from "../images/backgrounds/Marketplace_result.webp";
import fourteen from "../images/backgrounds/Beauty & Lifestyle_result.webp";
import fifteen from "../images/backgrounds/On Demand_result.webp";
import icon1 from "../images/roadmap icon/automation_result.webp";
import icon2 from "../images/roadmap icon/roadmap_result.webp";
import icon3 from "../images/roadmap icon/security_result.webp";
import icon4 from "../images/roadmap icon/system-integration_result.webp";

const industries = [
  {
    id: "4ee2a6c7",
    title: "IT Solutions for Healthcare",
    slug: "healthcare",
    hero: {
      heading:
        "Healthcare IT & Software Solutions – Enabling Smarter Patient Care",
      subheading: "Our Healthcare IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: one,
    },
    subdescription: [
      "Electronic Health Records (EHR) Systems – Streamline patient record maintenance with recoverable and secure electronic health information.",
      'Telemedicine & Remote Care – Enable remote patient care and treatment by physicians using innovative telehealth platforms. These solutions are supported with <a href="/app-development-services">App Development</a> expertise to provide mobile-friendly healthcare access.',
      "Telemedicine & Remote Care – Enable remote patient care and treatment by physicians using innovative telehealth platforms. These solutions are supported with App Development expertise to provide mobile-friendly healthcare access.",
      'Patient Scheduling Systems – Smart scheduling systems for appointments to reduce wait time and streamline hospital operations, designed with <a href="/ui-ux-development-services">UI/UX Design</a> principles for better patient experience.',
      "Healthcare Analytics & Reporting – Data-driven dashboards to improve decision-making for quality and performance monitoring.",
      "Security & Compliance Solutions – HIPAA-compliant environments with advanced data security, encryption, and access controls.",
    ],
    description: `Healthcare is experiencing a huge digital transformation and is being led by technology to improve patient care, operational efficiency, and security of data. Hospitals, clinics, laboratories, and telemedicine centers of the present time need scalable, smart, and secure solutions to address mounting demands. RashTech Info, Top Healthcare Solution Company in Alwar, offers innovative Healthcare IT Services in India as well as internationally. Our HealthTech solutions are designed to automate processes, enhance patient engagement, and meet international standards. For building scalable digital platforms, we also specialize in <a href="/web-development-services" >Web Development</a> that ensures seamless healthcare applications.`,

    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    // features: [
    //   "HIPAA/GDPR compliance",
    //   "Interoperability (FHIR/HL7)",
    //   "Patient portals",
    // ],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Healthcare Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?healthcare,app",
      },
    ],
    articles: [
      {
        title: "Modern Healthcare tech stack",
        url: "#",
        image: "https://source.unsplash.com/800x600/?healthcare,technology",
      },
    ],
    faqs: [
      {
        q: "Do you also have healthcare software for clinics and hospitals?",
        a: "Yes, we develop customized solutions for telehealth organizations, diagnostic centers, hospitals, and clinics.",
      },
      {
        q: "How do you ensure data privacy in healthcare software?",
        a: "We use robust encryption, secure access, and follow healthcare regulations such as HIPAA and local law.",
      },
      {
        q: "How many days will it take to implement a healthcare IT solution?",
        a: "Project timeline will be based on complexity – small systems may take 2–3 months, while enterprise platforms may require 4–6 months or more.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      {
        title: "EHR & Interoperability",
        desc: "FHIR/HL7 interfaces, care coordination, and portals.",
      },
      {
        title: "Telehealth & RPM",
        desc: "Virtual visits, remote monitoring, and triage.",
      },
      {
        title: "Revenue Cycle",
        desc: "Eligibility, coding, claims, and denials.",
      },
    ],
    outcomeTitle: "Healthcare Outcome ",
    outcome: [
      "Increased efficiency through automation and fewer manual errors.",
      "Improved patient satisfaction with seamless digital processes.",
      "Smarter decision-making with advanced data analytics and reporting.",
      "Stronger compliance and reduced risks with HIPAA-ready secure systems.",
      "Wider digital reach via telemedicine and mobile-first platforms.",
      "Enhanced healthcare brand presence with professional design and digital support in Alwar.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for healthcare technology solutions in Alwar ensures smarter operations and stronger patient engagement. Along with secure and scalable IT systems, we also support healthcare providers with <a href='/graphic-design-services'>graphic design</a> in Alwar that strengthens digital presence, improves patient trust, and creates a professional brand identity online.",
  },
  {
    id: "bd96338c",
    title: "IT Solutions for Education & E-Learning",
    slug: "education",
    hero: {
      heading:
        "Education IT & Software Solutions – Smarter Learning with Technology",
      subheading:
        "End-to-end software and services for education & e-learning organizations.",
      cta: { label: "Get Started", anchor: "#contact" },
      image: two,
    },
    subdescription: [
      "Learning Management Systems (LMS) – Comprehensive platforms for course management, assessments, and student tracking.",
      'Virtual Classrooms & E-Learning – Interactive online classrooms with real-time engagement tools, supported by <a href="/app-development-services"> mobile app development </a> for anytime access.',
      "Student Information Systems (SIS) – Manage student data, attendance, grading, and academic history.",
      "Digital Library & Content Management – Centralized access to books, journals, and multimedia study materials.",
      "Administration & Fee Management Software – Automate fee collection, scheduling, and reports.",
      'AI & Analytics for Education – Insights into student performance, behavior, and learning patterns, enhanced with <a href="/ui-ux-development-services"> user-friendly UI/UX design </a>.',
    ],
    description:
      'The education industry is transforming rapidly with the adoption of digital learning and smart campuses. From e-learning platforms to virtual classrooms, institutions need innovative IT solutions to improve learning outcomes and administration. RashTech Info, the Top Education Solutions Company in Alwar, provides world-class Education IT Services in India and globally. Our EdTech solutions empower schools, colleges, universities, and training institutes to scale efficiently and deliver high-quality education. To build robust digital platforms, we also specialize in <a href="/custom-software-services">custom web development</a>.',
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    // features: ["LTI/xAPI", "Accessibility (WCAG)", "Proctoring"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Education Platform",
        summary: "Flagship implementation and rollout",
        image:
          "https://source.unsplash.com/800x600/?education-and-e-learning,app",
      },
    ],
    articles: [
      {
        title: "Modern Education & E-Learning tech stack",
        url: "#",
        image:
          "https://source.unsplash.com/800x600/?education-and-e-learning,technology",
      },
    ],
    faqs: [
      {
        q: "Do you create e-learning platforms for schools and colleges?",
        a: "Yes, we design customized platforms for schools, universities, and training institutes.",
      },
      {
        q: "How secure are your education IT solutions?",
        a: "We use strong encryption, secure logins, and compliance with education standards to protect student data.",
      },
      {
        q: "Can your systems integrate with existing software?",
        a: "Yes, our solutions can integrate with ERPs, CRMs, and other third-party tools used by educational institutions.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "LMS & LXP", desc: "Courses, assessments, and credentials." },
      {
        title: "Virtual Classroom",
        desc: "Live sessions, breakout rooms, and attendance.",
      },
      {
        title: "Analytics",
        desc: "Engagement, mastery, and retention insights.",
      },
    ],
    outcomeTitle: "Education & E-Learning Outcome",
    outcome: [
      "Streamlined student and staff management with secure digital systems.",
      "Enhanced learning experiences through e-learning apps and virtual classrooms.",
      "Smarter academic decisions with analytics, performance tracking, and reporting.",
      "Increased admissions and enrollment with SEO-friendly education portals.",
      "Wider digital presence in Alwar via mobile-first and online education platforms.",
      "Stronger institutional branding with engaging video editing and digital marketing support.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for education IT solutions in Alwar delivers measurable improvements in learning outcomes and digital engagement. Our expertise in e-learning platforms, school/college management systems, and <a href='/video-editing-services'>video editing</a> support helps educational institutions modernize teaching methods, enhance student experiences, and expand their reach. By combining secure technology with creative digital strategies, we enable Alwar-based schools, colleges, and training centers to grow smarter and more efficiently.",
  },
  {
    id: "c482980d",
    title: "IT Solutions for Finance",
    slug: "finance",
    hero: {
      heading: "Finance & FinTech Solutions – Safe, Secure, and Future-Fit",
      subheading: "Our IT Finance Services",
      cta: { label: "Get Started", anchor: "#contact" },
      image: three,
    },
    description:
      'Speed, security, and accuracy are the key needs of the financial sector. With the rapid growth of digital banking, mobile payments, and investment platforms, financial institutions require innovative IT solutions to remain competitive and regulatory compliant. RashTech Info, the Top Finance Solutions Company in Alwar, offers world-class Finance IT Services in India and globally. Our FinTech expertise helps banks, NBFCs, insurance companies, and investment firms with secure, scalable technology that builds trust, boosts profitability, and enhances customer satisfaction. To achieve seamless platforms, we also provide <a href="/web-development-services">Web Development</a> for financial applications.',
    subdescription: [
      "Digital Banking Solutions – Internet banking, mobile banking, and digital wallet platforms.",
      "Financial Management Software – Business and personal accounting, budgeting, and reporting software.",
      "Payment Gateway Integration – Secure online payment solutions with multi-currency support.",
      "Trading & Investment Platforms – Stock trading, portfolio management, and wealth advisory solutions.",
      "Risk & Compliance Management – Automated compliance software for RBI, SEBI, and global regulations.",
      'Fraud Detection & Security Systems – AI-powered systems for fraud prevention and data security, supported by <a href="/app-development-services">App Development</a> for mobile-first banking.',
    ],
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["PCI DSS", "Open banking APIs", "Fraud monitoring"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Finance Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?finance,app",
      },
    ],
    articles: [
      {
        title: "Modern Finance tech stack",
        url: "#",
        image: "https://source.unsplash.com/800x600/?finance,technology",
      },
    ],
    faqs: [
      {
        q: "Do you create mobile apps for digital wallets and banking?",
        a: "Yes, we develop secure mobile banking, payment, and financial management apps.",
      },
      {
        q: "How do you make financial solutions secure?",
        a: "We use robust encryption, two-factor authentication, fraud detection technology, and compliance with global financial standards.",
      },
      {
        q: "Are your finance solutions compatible with legacy banking systems?",
        a: "Yes, our solutions can integrate seamlessly with core banking, ERP, and third-party APIs.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "Digital Onboarding", desc: "KYC/AML, eKYC, and risk scoring." },
      {
        title: "Payments & Cards",
        desc: "Instant transfers, wallets, and PCI DSS controls.",
      },
      {
        title: "Risk & Compliance",
        desc: "Fraud detection and regulatory reporting.",
      },
    ],
    outcomeTitle: "Finance Outcome",
    outcome: [
      "Streamlined financial operations with secure and automated platforms.",
      "Improved customer experience through user-friendly mobile and web portals.",
      "Smarter financial planning with analytics-driven insights and reporting.",
      "Increased client base and revenue with secure online transactions.",
      "Wider reach in Alwar with SEO-friendly finance websites and SMO-powered campaigns.",
      "Stronger finance brand presence with ongoing digital marketing and consultancy support.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for finance IT solutions in Alwar ensures measurable growth, efficiency, and client engagement. Our expertise in digital finance platforms, secure transaction systems, and <a href='/smo-services'>SMO services</a> helps financial institutions streamline operations, attract more clients, and build stronger digital visibility. By combining advanced financial technology with impactful social media strategies, we empower Alwar-based finance firms to achieve both trust and business expansion.",
  },
  {
    id: "245585aa",
    title: "IT Solutions for Legal & Consultancy",
    slug: "legal-consultancy",
    hero: {
      heading:
        "Legal & Consultancy Solutions – Making Compliance and Client Management Easier",
      subheading: "Our Legal & Consultancy IT Services",
      cta: { label: "Get Started", anchor: "#contact" },
      image: five,
    },
    description:
      'The legal and consultancy industry depends on accuracy, reliability, and efficiency. Today, law firms, consultants, and advisory bureaus need advanced IT solutions to manage cases, ensure compliance, and improve client communication. RashTech Info, the Best Legal Solutions Company in Alwar, provides customized Legal IT Services in India and worldwide. Our solutions empower legal professionals with smarter tools, secure environments, and faster services. To develop scalable platforms for law firms, we also provide professional <a href="/web-development-services">web application development</a>.',
    subdescription: [
      "Case & Document Management Systems – Secure digital platforms for storing case files, contracts, and sensitive legal documents.",
      "Compliance & Risk Management Tools – Automated tools to maintain compliance with laws and industry standards.",
      "Client Relationship Management (CRM) – Track client details, interactions, and case progress effortlessly.",
      "Legal Research & Knowledge Management – AI-powered research platforms and digital libraries for informed decision-making.",
      "Time Tracking & Billing Solutions – Automate timekeeping, billing, and invoicing for lawyers and consultants.",
      'Data Security & Confidentiality Systems – Encryption-based solutions with access control for safeguarding confidential data, designed with intuitive <a href="/ui-ux-development-services">UI/UX design</a>.',
    ],
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["eDiscovery", "Knowledge graphs", "Time & billing"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Legal Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?legal-and-consultancy,app",
      },
    ],
    articles: [
      {
        title: "Modern Legal & Consultancy tech stack",
        url: "#",
        image:
          "https://source.unsplash.com/800x600/?legal-and-consultancy,technology",
      },
    ],
    faqs: [
      {
        q: "Do you provide solutions for both small and large law firms?",
        a: "Yes, our platforms are scalable for solo practitioners, medium firms, and large consultancies.",
      },
      {
        q: "How do you ensure data security in legal solutions?",
        a: "We use encryption, multi-factor authentication, and strict compliance with global security standards.",
      },
      {
        q: "Can billing and client management be combined in one platform?",
        a: "Yes, we develop end-to-end solutions integrating billing, case management, and CRM features.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      {
        title: "Document & Knowledge",
        desc: "Search, precedents, and drafting aids.",
      },
      {
        title: "CLM & eSignature",
        desc: "Contracts, workflows, and approvals.",
      },
      {
        title: "Engagement Portals",
        desc: "Secure collaboration and billing.",
      },
    ],
    outcomeTitle: "Legal & Consultancy Outcome",
    outcome: [
      "Streamlined client and case management with secure digital solutions.",
      "Enhanced client experience through mobile-first and user-friendly platforms.",
      "Smarter decision-making with analytics, reporting, and document management.",
      "Increased client base and revenue for legal & consultancy firms in Alwar.",
      "Wider online visibility with SEO-friendly websites and targeted SMO campaigns.",
      "Stronger professional brand presence with ongoing digital marketing and consultancy support.",
    ],

    outcomeParagraph:
      "Partnering with RashTech Info for legal and consultancy IT solutions in Alwar delivers measurable client engagement and operational efficiency. Our expertise in digital platforms, case management systems, and <a href='/smo-services'>SMO services</a> helps law firms and consultants build credibility, attract more clients, and strengthen their digital presence. By integrating secure systems with powerful online strategies, we enable Alwar-based consultants and legal professionals to achieve growth, visibility, and long-term trust.",
  },
  {
    id: "eaff1bdf",
    title: "IT Solutions for Insurance",
    slug: "insurance",
    hero: {
      heading:
        "Insurance IT & Software Solutions – Smarter, Faster, and More Secure",
      subheading: "Our Insurance IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: seven,
    },
    subdescription: [
      "Policy & Customer Management Systems – Manage policy issuance, renewals, and customer records in one place.",
      "Claims Processing Solutions – Automate filing, verification, and settlement of claims with minimal paperwork.",
      "Insurance Mobile Apps – Easy-to-use apps for managing policies, claims, and payments, supported by custom app development.",
      "CRM for Insurance Agents – Track leads, manage interactions, and improve customer retention.",
      "Risk & Fraud Detection Systems – AI-powered fraud prevention and claim authentication.",
      'Analytics & Reporting Tools – Insights into customer behavior, risk analysis, and performance tracking, designed with modern <a href="/ui-ux-development-services">UI/UX solutions</a>.',
    ],
    description:
      "The insurance industry is rapidly adopting digital transformation to handle policies, claims, and customer interactions more efficiently. Customers today expect real-time services, simple processes, and secure platforms for their insurance needs. RashTech Info, the Best Insurance Solutions Company in Alwar, delivers innovative Insurance IT Services in India and worldwide. Our InsurTech solutions are designed to minimize risks, automate workflows, and deliver seamless digital experiences for both policyholders and insurers. For building secure online portals, we also offer enterprise <a href='/web-development-services'>web development</a>.",
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["Rating engines", "Document ingestion", "Compliance rules"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Insurance Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?insurance,app",
      },
    ],
    articles: [
      {
        title: "Modern Insurance tech stack",
        url: "#",
        image: "https://source.unsplash.com/800x600/?insurance,technology",
      },
    ],
    faqs: [
      {
        q: "Do you provide mobile apps for insurance customers?",
        a: "Yes, we build Android and iOS apps for managing policies, claims, and premium payments.",
      },
      {
        q: "Can your solutions automate claim handling?",
        a: "Absolutely. Our claim systems minimize manual work and speed up settlement times.",
      },
      {
        q: "Are these solutions suitable for small insurance agencies?",
        a: "Yes, our platforms are scalable and customizable for agencies, brokers, or large insurance companies.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "Policy Admin", desc: "Quoting, issuance, and endorsements." },
      { title: "Claims", desc: "FNOL, adjudication, and subrogation." },
      { title: "Pricing & UW", desc: "Risk signals, scoring, and rules." },
    ],
    outcomeTitle: "Insurance Outcome",
    outcome: [
      "Streamlined policy and claims management with digital automation.",
      "Enhanced customer experience through self-service portals and mobile apps.",
      "Smarter business insights with analytics-driven decision-making and reporting.",
      "Increased revenue through online policy sales and secure payment systems.",
      "Wider digital reach in Alwar with SEO-friendly platforms and customer-focused solutions.",
      "Stronger insurance brand identity with professional graphic design and digital marketing support.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for insurance IT solutions in Alwar delivers measurable results in client engagement and operational efficiency. Our expertise in insurance management systems, customer portals, and <a href='/graphic-design-services'>graphic design</a> helps insurance providers streamline policy handling, build customer trust, and strengthen their digital presence. By integrating secure platforms with creative branding strategies, we empower Alwar-based insurance firms to achieve both efficiency and long-term growth.",
  },
  {
    id: "68c16c94",
    title: "IT Solutions for Logistics",
    slug: "logistics",
    hero: {
      heading:
        "Logistics & Supply Chain Solutions – Enabling Efficiency and Growth",
      subheading: "Our IT Solutions for Logistics",
      cta: { label: "Get Started", anchor: "#contact" },
      image: six,
    },
    subdescription: [
      "Fleet & Transport Management Systems – Real-time vehicle tracking, route monitoring, and fuel optimization.",
      "Warehouse & Inventory Management – Automated stock updates, order processing, and inventory control.",
      "Supply Chain Visibility Platforms – End-to-end tracking with advanced analytics and reporting.",
      "Route Optimization Solutions – AI-based algorithms to reduce delays, fuel costs, and travel time.",
      "Order & Delivery Management Systems – Streamlined order processing, proof of delivery, and notifications.",
      "IoT & Smart Logistics Integration – Sensor tracking, temperature monitoring, and predictive maintenance, enhanced with mobile app development for on-the-go management.",
    ],
    description:
      "The logistics and supply chain industry is the backbone of global commerce, and technology drives its transformation. From real-time tracking to automated inventory management, businesses need smart IT solutions to stay competitive. RashTech Info, Top leading Logistics Solutions Company in Alwar, delivers tailored Logistics IT Solutions in India and worldwide. Our platforms help organizations reduce costs, optimize operations, and improve delivery performance. For scalable digital platforms, we also provide custom <a href='/web-development-services'>web development services</a>.",
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: [
      "Carrier integrations",
      "Route optimization",
      "Proof of delivery",
    ],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Logistics Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?logistics,app",
      },
    ],
    articles: [
      {
        title: "Modern Logistics tech stack",
        url: "#",
        image: "https://source.unsplash.com/800x600/?logistics,technology",
      },
    ],
    faqs: [
      {
        q: "Do you provide solutions for SMEs as well as large logistics enterprises?",
        a: "Yes, our solutions are scalable for startups, SMEs, and large corporates.",
      },
      {
        q: "Can your logistics systems integrate with ERP or CRM platforms?",
        a: "Yes, our software integrates seamlessly with ERPs, CRMs, and third-party tools.",
      },
      {
        q: "How do your solutions reduce operational costs?",
        a: "By automating inventory, routing, and reducing manual errors, our platforms deliver measurable cost savings.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "TMS", desc: "Plan, execute, and settle multi-modal moves." },
      { title: "WMS", desc: "Inbound, outbound, and inventory control." },
      {
        title: "Control Tower",
        desc: "Predictive ETAs and exception management.",
      },
    ],
    outcomeTitle: "Logistics Outcome",
    outcome: [
      "Optimized fleet and route management with real-time tracking systems.",
      "Improved supply chain visibility through digital dashboards and analytics.",
      "Smarter decision-making with AI-driven logistics forecasting and reporting.",
      "Increased customer satisfaction with faster deliveries and secure transactions.",
      "Wider reach in Alwar through SEO-friendly and mobile-first logistics platforms.",
      "Stronger logistics brand presence with engaging video editing and digital marketing support.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for logistics IT solutions in Alwar ensures streamlined operations and measurable growth. Our expertise in transport management systems, supply chain automation, and <a href='/video-editing-services'>video editing</a> support helps logistics providers improve efficiency, reduce costs, and enhance their market presence. By combining advanced technology with creative digital strategies, we empower Alwar-based logistics companies to deliver faster, smarter, and more reliable services.",
  },
  {
    id: "e86883c7",
    title: "IT Solutions for Manufacturing",
    slug: "manufacturing",
    hero: {
      heading:
        "Manufacturing IT & Software Solutions – Empowering Smart Factories and Efficiency",
      subheading: "Our Manufacturing IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: nine,
    },
    subdescription: [
      "ERP & Production Management Systems – Complete solutions for production planning, scheduling, and inventory management.",
      "IoT & Smart Factory Solutions – Real-time machine monitoring, predictive maintenance, and automation.",
      "Supply Chain & Inventory Management – Streamline raw material procurement, stock tracking, and logistics.",
      "Quality Control & Compliance Software – Quality products guaranteed through automated compliance testing and reporting.",
      'Manufacturing Mobile Apps – Workforce management, equipment tracking, and production monitoring apps, backed by enterprise <a href="/app-development-services">mobile app development</a>.',
      'Analytics & Reporting Tools – Data-based performance monitoring dashboards and predictive analytics, crafted with cutting-edge <a href="/ui-ux-development-services">UI/UX design</a>.',
    ],
    description:
      'The manufacturing sector is heading towards Industry 4.0, wherein automation, IoT, and digital platforms revolutionize operations. Be it smart factories or supply chain optimization, manufacturers need scalable IT solutions to improve productivity, bring down costs, and ensure quality. RashTech Info, the Top Manufacturing IT Solutions Company in Alwar, provides innovative Manufacturing IT Services in India and globally. Our solutions assist factories, plants, and industrial businesses in upgrading systems and optimizing processes. For scalable digital platforms, we also offer <a href="/web-development-services">custom web development solutions</a>.',
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["Predictive maintenance", "SPC/quality", "Connected worker"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Manufacturing Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?manufacturing,app",
      },
    ],
    articles: [
      {
        title: "Modern Manufacturing tech stack",
        url: "#",
        image: "https://source.unsplash.com/800x600/?manufacturing,technology",
      },
    ],
    faqs: [
      {
        q: "Do you offer ERP solutions to manufacturing businesses?",
        a: "Yes, we develop tailored ERP platforms for small, medium, and large manufacturers.",
      },
      {
        q: "Can your solutions be integrated with legacy factory systems?",
        a: "Yes, our platforms are integrated with legacy machinery, ERP, and third-party software.",
      },
      {
        q: "Do you have mobile apps for workforce management in factories?",
        a: "Yes. We develop apps for real-time workforce scheduling, machine tracking, and production monitoring.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "MES & OEE", desc: "Line monitoring, downtime, and quality." },
      { title: "Digital Twin", desc: "Simulation and process optimization." },
      { title: "SCM & Traceability", desc: "Supplier quality and genealogy." },
    ],
    outcomeTitle: "Manufacturing Outcome",
    outcome: [
      "Streamlined production and resource management with automation tools.",

      "Improved supply chain efficiency through digital tracking and reporting.",

      "Smarter decision-making with data analytics and performance monitoring.",

      "Increased revenue with optimized workflows and reduced operational costs.",

      "Wider digital presence for Alwar manufacturers with SEO-friendly platforms.",

      "Stronger brand identity through professional graphic design and digital marketing support.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for manufacturing IT solutions in Alwar delivers measurable efficiency and growth. Our expertise in ERP systems, automation tools, and <a href='/graphic-design-services'>graphic design</a> ensures streamlined production processes, better resource utilization, and a stronger digital presence for manufacturers. By integrating secure platforms with creative branding strategies, we help Alwar-based manufacturing businesses improve operations, boost productivity, and enhance market visibility.",
  },
  {
    id: "358ad2fa",
    title: "IT Solutions for Marketplace",
    slug: "marketplace",
    hero: {
      heading:
        "Marketplace IT & Software Solutions – Seamlessly Connecting Buyers and Sellers",
      subheading: "Our Marketplace IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: thirteen,
    },
    subdescription: [
      "Multi-Vendor Marketplace Platforms – Allow sellers to register, add products, and process orders.",
      'Marketplace Mobile Apps – Seller and buyer apps with enhanced features such as chat, ratings, and secure payments, developed using <a href="/app-development-services">custom app development</a>.',
      "Payment Gateway & Wallet Integration – Secure and multi-currency transactions for international marketplaces.",
      "Vendor & Customer Management Systems – Vendors, customer management, and communication tools.",
      'Analytics & Reporting Tools – Sales, vendor, and customer behavior insights, bolstered by intuitive <a href="/ui-ux-development-services">UI/UX design</a>.',
      "E-Commerce Extensions – Such as coupons, loyalty schemes, and auto-notifications.",
    ],
    description:
      "The online marketplace sector is booming with e-marketplaces that join buyers and sellers from various industries — from services and e-commerce to B2B trade. Companies require secure, scalable, and intuitive marketplace solutions to manage substantial transaction and customer volumes. RashTech Info, Best Marketplace IT Solutions Company in Alwar, is a provider of cutting-edge Marketplace IT Services in India and worldwide. Our solutions help businesses establish multi-vendor marketplaces, process payments, and establish customer trust. For the development of highly performing marketplaces, we also provide scalable <a href='/web-development-services'>web development</a>.",
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["Omnichannel", "Size/fit guidance", "Returns management"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Fashion Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?fashion-and-lifestyle,app",
      },
    ],
    articles: [
      {
        title: "Modern Fashion & Lifestyle tech stack",
        url: "#",
        image:
          "https://source.unsplash.com/800x600/?fashion-and-lifestyle,technology",
      },
    ],
    faqs: [
      {
        q: "Do you develop multi-vendor marketplace platforms?",
        a: "Yes, we create secure and scalable platforms for B2C and B2B marketplaces.",
      },
      {
        q: "Do your solutions support integration with third-party payment systems?",
        a: "Yes. We offer smooth integration with international payment gateways and wallets.",
      },
      {
        q: "Do you create marketplace mobile apps?",
        a: "Yes, we develop buyer and seller apps with chat, ratings, and advanced features.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "Commerce & OMS", desc: "Catalog, payments, and fulfillment." },
      {
        title: "Clienteling & Loyalty",
        desc: "Personalization and membership.",
      },
      {
        title: "PLM & Forecasting",
        desc: "Design-to-shelf and demand planning.",
      },
    ],
    outcomeTitle: "Marketplace Outcome",
    outcome: [
      "Simplified vendor and product management with robust marketplace platforms.",

      "Enhanced buyer-seller engagement through mobile apps and social media integrations.",

      "Smarter decision-making with advanced analytics and reporting.",

      "Increased sales and revenue for Alwar-based marketplaces with secure transactions.",

      "Wider reach through SEO-friendly listings and targeted SMO campaigns.",

      "Stronger brand presence with continuous support, marketing, and growth strategies.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for marketplace development in Alwar ensures scalable growth and seamless digital operations. Our expertise in marketplace IT solutions, mobile-first platforms, and <a href='/smo-services'>SMO services</a> helps businesses connect buyers and sellers effortlessly while boosting visibility in the Alwar market. By combining secure technology with effective social media strategies, we enable marketplace platforms to achieve higher engagement, stronger trust, and consistent revenue growth.",
  },
  {
    id: "f358ad2fa",
    title: "IT Solutions for On-Demand",
    slug: "on-demand",
    hero: {
      heading: "On-Demand IT & Software Solutions – Quick, Agile, and Scalable",
      subheading: "Our On-Demand IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: fifteen,
    },
    subdescription: [
      'On-Demand Mobile Apps – Strong apps for food delivery, ride-hailing, home services, and more, designed through bespoke <a href="/app-development-services">app development</a> .',
      "Real-Time Tracking Systems – Live GPS tracking for drivers, deliveries, and service providers.",
      "Online Booking & Scheduling – In-app booking with calendar sync and reminders.",
      "Payment & Wallet Integration – Secure payments with multi-currency handling.",
      'Customer & Service Provider Dashboards – Minimalist dashboards built using contemporary <a href="/ui-ux-development-services">UI/UX design</a> for effortless administration.',
      "Analytics & Performance Insights – Data-based tools for tracking efficiency, revenue, and customer behavior.",
    ],
    description:
      'The on-demand economy is redefining the way individuals are accessing services — from food delivery and ride-hailing to healthcare and home services. Customers anticipate real-time, secure, and easy-to-use platforms to book and schedule services instantly. RashTech Info, the Best On-Demand IT Solutions Company in Alwar, offers cutting-edge On-Demand IT Services in India and across the globe. Our solutions enable startups and businesses to develop scalable on-demand platforms with seamless functionality and delightful experiences. To develop strong platforms, we also provide bespoke <a href="/web-development-services">web development solutions</a>.',
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["Omnichannel", "Size/fit guidance", "Returns management"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Fashion Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?fashion-and-lifestyle,app",
      },
    ],
    articles: [
      {
        title: "Modern Fashion & Lifestyle tech stack",
        url: "#",
        image:
          "https://source.unsplash.com/800x600/?fashion-and-lifestyle,technology",
      },
    ],
    faqs: [
      {
        q: "Do you build food ordering and ride-hailing apps?",
        a: "Yes, we design bespoke apps for food ordering, ridesharing, and various on-demand services.",
      },
      {
        q: "Do your solutions support high traffic and real-time tracking?",
        a: "Yes, definitely. Our platforms are elastic and designed for real-time GPS tracking.",
      },
      {
        q: "Do you deliver apps for both consumers and service providers?",
        a: "Yes, we create apps and dashboards for customers, service providers, and admins.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "Commerce & OMS", desc: "Catalog, payments, and fulfillment." },
      {
        title: "Clienteling & Loyalty",
        desc: "Personalization and membership.",
      },
      {
        title: "PLM & Forecasting",
        desc: "Design-to-shelf and demand planning.",
      },
    ],
    outcomeTitle: "On-Demand Outcome",
    outcome: [
      "Streamlined service booking and delivery management through custom apps.",

      "Enhanced customer experience with intuitive UI/UX and real-time updates.",

      "Smarter business growth with analytics-driven decision-making.",

      "Increased revenue with secure payment gateways and loyalty features.",

      "Wider reach in Alwar through SEO-friendly and mobile-first on-demand platforms.",

      "Stronger brand presence with engaging video editing and digital marketing campaigns.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for on-demand app development in Alwar ensures measurable growth and customer satisfaction. Our expertise in on-demand IT solutions, mobile app development, and <a href='/video-editing-services'>video editing</a> support helps local businesses deliver seamless services, enhance customer engagement, and build stronger digital visibility. By combining advanced technology with creative digital strategies, we empower Alwar-based startups and enterprises to scale faster in the competitive on-demand market",
  },
  {
    id: "f358ad2fb",
    title: "IT Solutions for Retail",
    slug: "retail",
    hero: {
      heading: "Retail IT & Software Solutions – Smarter Shopping Experiences",
      subheading: "Our Retail IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: ten,
    },
    subdescription: [
      "E-Commerce Platforms – Secure and scalable online shops with enhanced product and order management.",
      'Retail Mobile Apps – Custom shopping apps with suggestions, wishlists, and mobile pay, driven by custom <a href="/app-development-services">app development</a>.',
      "POS & Billing Systems – More intelligent billing systems that have inventory integration and reporting.",
      "Customer Loyalty Programs – CRM systems used to handle offers, discounts, and rewards.",
      'Retail Analytics & Reporting – Sales, customer behavior, and trend analysis, enabled by user-centric <a href="/ui-ux-development-services">UI/UX design</a>.',
      "Inventory & Supply Chain Management – Real-time tracking and optimization of stock, suppliers, and logistics.",
    ],
    description: `The retail sector is evolving fast with the development of e-commerce, online payments, and customer personalization. From web stores to intelligent POS systems, retailers need to implement the latest technology to compete and meet customer expectations. RashTech Info, Top Retail IT Solutions provider in Alwar, offers the best Retail IT Services in India and worldwide. Our business solutions enable organizations to streamline operations, enhance customer loyalty, and maximize sales. For creating high-performance e-commerce and retail websites, we also offer <a href="/web-development-services">professional web development</a>.`,
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["Omnichannel", "Size/fit guidance", "Returns management"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Fashion Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?fashion-and-lifestyle,app",
      },
    ],
    articles: [
      {
        title: "Modern Fashion & Lifestyle tech stack",
        url: "#",
        image:
          "https://source.unsplash.com/800x600/?fashion-and-lifestyle,technology",
      },
    ],
    faqs: [
      {
        q: "Do you construct e-commerce websites for retailers?",
        a: "Yes, we construct secure, scalable e-commerce websites for small stores to large retailers.",
      },
      {
        q: "Do your solutions integrate with existing POS systems?",
        a: "Yes, our solutions are integrated with POS, ERP, and other retail platforms.",
      },
      {
        q: "Do you offer mobile apps for retail consumers?",
        a: "Yes. We create branded retail apps with secure payments and tailored experiences.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "Commerce & OMS", desc: "Catalog, payments, and fulfillment." },
      {
        title: "Clienteling & Loyalty",
        desc: "Personalization and membership.",
      },
      {
        title: "PLM & Forecasting",
        desc: "Design-to-shelf and demand planning.",
      },
    ],
    outcomeTitle: "Retail Outcome",
    outcome: [
      " Streamlined inventory and store management with digital automation in Alwar.",

      "Enhanced customer shopping experience through eCommerce and mobile-first retail apps.",

      "Smarter business decisions with retail analytics and performance reporting.",

      "Increased sales and revenue growth for Alwar retailers with digital promotions and secure payments.",

      "Wider local and online reach with SEO-friendly and location-based digital presence.",

      "Stronger retail brand identity in Alwar with creative graphic design and marketing support.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for retail technology solutions in Alwar delivers measurable business results. Our expertise in Retail IT, eCommerce platforms, and <a href='/graphic-design-services'>graphic design</a> ensures seamless store operations, improved customer experiences, and a stronger retail brand presence in the Alwar market. By combining secure platforms with creative digital strategies, we help local retailers achieve both operational efficiency and wider digital visibility.",
  },
  {
    id: "f358ad2fc",
    title: "IT Solutions for Sports",
    slug: "sports",
    hero: {
      heading:
        "Sports IT & Software Solutions – Driving Performance and Engagement",
      subheading: "Our Sports IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: twelve,
    },
    subdescription: [
      "Sports Management Systems – Platforms for managing players, teams, schedules, and tournaments.",
      "Sports Mobile Applications – Applications for fans, players, and teams to interact, practice, and get informed using mobile <a href='/app-development-services'>Application Development</a>.",
      "Fitness & Training Platforms – Online training, gym maintenance, and performance monitoring platforms.",
      "Ticketing & Event Management Systems – Internet reservations for matches, events, and tournaments.",
      'Sports Analytics & Reporting – In-time performance data and forecast analytics, augmented by interactive <a href="/ui-ux-development-services">UI/UX design</a>.',
      "	Fan Engagement Solutions – Social platforms, live streaming, and social media integrations.",
    ],
    description: `The sports sector is adopting digital transformation as sports analytics, fan engagement platforms, and mobile apps are on the rise. Technology is influencing everything from sports academies and gyms to leagues and clubs in order to enhance performance and develop improved fan experiences. RashTech Info, the Best Sports IT Solutions Company in Alwar, provides cutting-edge Sports IT Services in India and worldwide. Our solutions enable organizations to manage teams, connect with fans, and generate revenue. Custom <a href="/web-development-services">web development</a> is also offered by us for high-performance and scalable digital platforms.`,
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["Omnichannel", "Size/fit guidance", "Returns management"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Fashion Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?fashion-and-lifestyle,app",
      },
    ],
    articles: [
      {
        title: "Modern Fashion & Lifestyle tech stack",
        url: "#",
        image:
          "https://source.unsplash.com/800x600/?fashion-and-lifestyle,technology",
      },
    ],
    faqs: [
      {
        q: "Do you offer apps for gyms and sports clubs?",
        a: "Yes, we develop personalized mobile apps for clubs, academies, and gyms.",
      },
      {
        q: "Are your solutions capable of ticketing and live event bookings?",
        a: "Yes, by all means. We offer secure and scalable event management systems.",
      },
      {
        q: "Do you provide sports analytics tools?",
        a: "Yes, we offer AI-driven analytics platforms to monitor player performance and team progress.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "Commerce & OMS", desc: "Catalog, payments, and fulfillment." },
      {
        title: "Clienteling & Loyalty",
        desc: "Personalization and membership.",
      },
      {
        title: "PLM & Forecasting",
        desc: "Design-to-shelf and demand planning.",
      },
    ],
    outcomeTitle: "Sports Outcome",
    outcome: [
      "Simplified operations for managing teams, events, and tournaments.",

      "More robust fan interaction with apps, websites, and community platforms.",

      "Enhanced player performance with analytics, reporting, and training support.",

      "Increased ticket sales and revenue generation through digital channels.",

      "Wider digital reach with mobile-first, SEO-friendly, and SMO-powered platforms.",

      "Stronger sports brand presence with design, media, and digital marketing integration.",
    ],
    outcomeParagraph:
      "Partnering with RashTech Info for sports technology solutions delivers measurable results. Our expertise in Sports IT, <a href='/smo-services'>SMO services</a>, and digital platforms ensures seamless operations for clubs, academies, and leagues while boosting fan engagement and global reach. By combining advanced analytics with creative digital strategies, we help sports organizations achieve both performance excellence and stronger online visibility.",
  },
  {
    id: "f358adfd",
    title: "IT Solutions for Travel & Tourism ",
    slug: "travel",
    hero: {
      heading:
        "Travel & Tourism IT Solutions – Smarter Bookings and Enhanced Experiences",
      subheading: "Our Travel IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: aath,
    },
    subdescription: [
      "Online Booking Engines – Simplify hotel, flight, and package bookings with real-time availability and secure payments.",
      'Travel Mobile Apps – Feature-rich mobile apps for booking, itinerary management, and mobile boarding passes, supported by <a href="/app-development-services">mobile app development</a>.',
      "CRM for Travel Agencies – Automate lead, like-minded customer, and communication for loyalty.",
      "Tour Management Systems – Automate group booking, transportation, and guided tour management.",
      'Travel Analytics & Reporting – Traveler behavior, booking, and revenue growth insights powered with intuitive <a href="/ui-ux-development-services">UI/UX design</a>.',
      "Payment & Currency Management – Multi-currency payment channels with fraud protection and secure payment.",
    ],
    description: `The travel and tourism industry is rapidly changing with the help of mobile apps, online websites, and smart booking systems. The modern-day tourists eagerly anticipate swift, personalized, and secure means for their holidays, reservations, and travel plans. RashTech Info is the Best Travel IT Solutions Company in Alwar, offering state-of-the-art Travel & Tourism IT Services in India and globally. With our solutions, travel agencies, tour operators, and hospitality businesses are empowered with end-to-end technology to upgrade customer experiences, increase sales, and work efficiently. As a supplement to our portal creation, we also provide <a href="/web-development-services">custom web development</a>.`,
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["Omnichannel", "Size/fit guidance", "Returns management"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Fashion Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?fashion-and-lifestyle,app",
      },
    ],
    articles: [
      {
        title: "Modern Fashion & Lifestyle tech stack",
        url: "#",
        image:
          "https://source.unsplash.com/800x600/?fashion-and-lifestyle,technology",
      },
    ],
    faqs: [
      {
        q: "Do you have travel booking apps for agencies and customers?",
        a: "Yes, we create customized mobile travel booking apps, itineraries, and secure payments.",
      },
      {
        q: "How safe are your booking systems online?",
        a: "We utilize secure payment gateways, fraud protection, and global compliance.",
      },
      {
        q: "Can your solutions handle global travel operations?",
        a: "Yes, our systems are scalable and facilitate multi-currency payments, multi-language support, and worldwide integrations.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "Commerce & OMS", desc: "Catalog, payments, and fulfillment." },
      {
        title: "Clienteling & Loyalty",
        desc: "Personalization and membership.",
      },
      {
        title: "PLM & Forecasting",
        desc: "Design-to-shelf and demand planning.",
      },
    ],
    outcomeTitle: "Travel Outcome",
    outcome: [
      "Increased bookings via faster and secure digital channels.",

      "Improved customer satisfaction with seamless travel experiences.",

      "Better management of tours, packages, and itineraries.",

      "Real-time feedback and tracking on reservations, cancellations, and payments.",

      "Stronger digital presence with SEO and mobile-first solutions.",

      "Wider audience engagement through social media optimization and promotions in Alwar.",
    ],
    outcomeParagraph: `RashTech Info empowers travel businesses in Alwar with advanced digital platforms that make bookings easier, improve customer experiences, and boost online visibility. Our expertise in <a href='/smo-services'>SMO services</a> in Alwar helps tour operators, agencies, and travel brands expand their reach, attract new customers, and strengthen their digital presence through targeted promotions.`,
  },
  {
    id: "358ad2fa",
    title: "IT Solutions for Beauty & Lifestyle",
    slug: "beauty-lifestyle",
    hero: {
      heading:
        "Beauty & Lifestyle IT & Software Solutions – Transforming Contemporary Living",
      subheading: "Our Beauty & Lifestyle IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: fourteen,
    },
    subdescription: [
      "Salon & Spa Booking Systems – Online booking, staff management, and payment integration.",
      'Beauty & Fashion Mobile Applications – Shopping and appointment applications with personalized suggestions, driven by <a href="/app-development-services">mobile application development</a>.',
      "Lifestyle Brand E-Commerce Platforms – Secure payment and inventory management online stores.",
      "Customer Relationship Management (CRM) – Handle client profiles, loyalty schemes, and offers.",
      'Wellness & Fitness Solutions – Gym, fitness trainer, and wellness program applications and platforms, augmented with contemporary <a href="/ui-ux-development-services">UI/UX design</a>.',
      "Analytics & Marketing Tools – Monitor customer activity, sales, and campaign results.",
    ],
    description: `The beauty and lifestyle sector is quickly going online with the growth of e-commerce, mobile applications, and digital marketing. From spas and beauty salons to fashion labels and wellness brands, companies require intelligent IT solutions to provide personalized consumer experiences, automate bookings, and expand web sales. RashTech Info, Best Beauty & Lifestyle IT Solutions Company in Alwar, offers cutting-edge Beauty & Lifestyle IT Services in India and worldwide. Our solutions enable businesses to book appointments, create digital stores, and develop engaging experiences. For scalable beauty and lifestyle websites, we also offer custom <a href="/web-development-services">web development</a> .`,
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["Omnichannel", "Size/fit guidance", "Returns management"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Fashion Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?fashion-and-lifestyle,app",
      },
    ],
    articles: [
      {
        title: "Modern Fashion & Lifestyle tech stack",
        url: "#",
        image:
          "https://source.unsplash.com/800x600/?fashion-and-lifestyle,technology",
      },
    ],
    faqs: [
      {
        q: "Do you offer apps for salons and lifestyle brands?",
        a: "Yes, we develop mobile apps for spas, salons, fitness, and fashion labels.",
      },
      {
        q: "Can your solutions accommodate e-commerce for beauty and lifestyle products?",
        a: "Yes, we create secure e-commerce websites with inventory and payment integration",
      },
      {
        q: "Do you have customer loyalty and engagement tools?",
        a: "Yes. We have CRM and loyalty program solutions for improved customer retention.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "Commerce & OMS", desc: "Catalog, payments, and fulfillment." },
      {
        title: "Clienteling & Loyalty",
        desc: "Personalization and membership.",
      },
      {
        title: "PLM & Forecasting",
        desc: "Design-to-shelf and demand planning.",
      },
    ],
    outcome: [
      "Increased sales with e-commerce websites and online booking platforms.",

      "Enhanced customer interaction through loyalty programs and mobile applications.",

      "Stronger brand awareness with digital-first strategies and creative visuals.",

      "Smarter insights with analytics and customer behavior tracking.",

      "Improved daily operations and better staff management.",

      "Eye-catching content and promotions with professional video editing in Alwar.",
    ],
    outcomeTitle: "Beauty & Lifestyle Outcome",
    outcomeParagraph:
      "RashTech Info helps beauty and wellness businesses in Alwar achieve higher customer engagement and brand growth through smart digital solutions. Along with secure platforms and e-commerce integration, our <a href='/video-editing-services'>video editing</a> in Alwar services enhance visual appeal, attract more clients, and boost online visibility for salons, spas, and beauty brands.",
  },
  {
    id: "d84514ac",
    title: "IT Solutions for Real Estate",
    slug: "real-estate",
    hero: {
      heading: "Transforming real-estate with scalable tech",
      subheading:
        "End-to-end software and services for real estate organizations.",
      cta: { label: "Get Started", anchor: "#contact" },
      image: four,
    },
    subdescription: [],
    description:
      "Real estate technology spans acquisition, development, leasing, and operations across residential, commercial, and industrial assets. Owners and operators adopt IoT sensors, access control, and smart building systems to improve safety, reduce utilities, and optimize space. Property management platforms streamline listings, tours, applications, payments, and renewals, while maintenance portals coordinate vendors and SLAs. For investors, data rooms and dashboards centralize rent rolls, expenses, valuations, and scenarios to inform capital decisions. Developers use BIM coordination and digital twins to reduce clashes and accelerate delivery. ESG expectations drive energy benchmarking, certifications, and retrofit programs, supported by granular metering and automated reporting. Hybrid work patterns increase demand for flexible, amenity‑rich environments and require dynamic utilization analytics. Integrated data pipelines connect CRM, leasing, work orders, and accounting to eliminate silos and support accurate forecasting. With secure multi‑tenant architecture and role‑based access, stakeholders can collaborate transparently. The result is higher NOI, improved tenant satisfaction, and resilient portfolios prepared for market cycles.",
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["IoT sensors", "Space utilization", "ESG tracking"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Real Estate Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?real-estate,app",
      },
    ],
    articles: [
      {
        title: "Modern Real Estate tech stack",
        url: "#",
        image: "https://source.unsplash.com/800x600/?real-estate,technology",
      },
    ],
    faqs: [
      {
        q: "How long does a typical project take?",
        a: "Pilot 8–12 weeks; phased rollout based on scope.",
      },
      {
        q: "Do you support integrations?",
        a: "Yes, REST/GraphQL, EDI where applicable, and iPaaS connectors.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      {
        title: "Property Management",
        desc: "Leasing, maintenance, and tenant portals.",
      },
      {
        title: "Smart Buildings",
        desc: "IoT, energy optimization, and safety.",
      },
      {
        title: "Investor Reporting",
        desc: "Performance dashboards and cash flows.",
      },
    ],
  },

  {
    id: "f358adff",
    title: "IT Solutions for Construction ",
    slug: "construction",
    hero: {
      heading:
        "Construction IT & Software Solutions – Developing Smarter with Technology",
      subheading: "Our Construction IT Solutions",
      cta: { label: "Get Started", anchor: "#contact" },
      image: elevan,
    },
    subdescription: [
      "Project Management Software – Complete project planning, scheduling, and resource management.",
      "Construction Mobile Apps – On-site reporting, task management, and safety monitoring apps built via enterprise <a href='/app-development-services'>App Development</a>.",
      "Building Information Modeling (BIM) Solutions – Smart construction through 3D modeling and digital twins.",
      "Compliance & Safety Management – Automated safety monitoring and compliance tracking.",
      "Inventory & Procurement Systems – Efficient raw material, supplier, and logistics management.",
      "Analytics & Reporting Tools – Real-time dashboards and reports, crafted with intuitive <a href='/ui-ux-development-services'>UI/UX design</a>.",
    ],
    description: `The construction sector is adopting digital change with technologies such as project management software, 3D modeling, and IoT monitoring. Both big infrastructure projects and residential complexes require scalable IT solutions to enhance efficiency, cut costs, and meet compliance. RashTech Info, India's Best Construction IT Solutions Company in Alwar, offers cutting-edge Construction IT Services in India and worldwide. Our solutions enable contractors, builders, and real estate developers to optimize operations and complete projects on time. For high-performance platforms, we also offer customized <a href="/web-development-services">web development solutions</a>.`,
    stats: [
      {
        label: "Market Size",
        value: "—",
        note: "placeholder; replace with figures",
      },
      {
        label: "Digital Adoption",
        value: "—",
        note: "placeholder; replace with KPIs",
      },
      {
        label: "Satisfaction Target",
        value: ">95%",
        note: "experience and outcomes",
      },
    ],
    strategies: [
      {
        title: "Roadmap",
        desc: "Prioritize initiatives by value and risk.",
        icon: icon2,
      },
      {
        title: "Integration",
        desc: "APIs and data pipelines to unify systems.",
        icon: icon4,
      },
      {
        title: "Automation",
        desc: "Workflow and AI to remove manual steps.",
        icon: icon1,
      },
      {
        title: "Security",
        desc: "Privacy, compliance, and resilience.",
        icon: icon3,
      },
    ],
    features: ["Omnichannel", "Size/fit guidance", "Returns management"],
    team: {
      blurb: "Cross-functional engineers and domain experts.",
      headcount: 25,
    },
    projects: [
      {
        name: "Fashion Platform",
        summary: "Flagship implementation and rollout",
        image: "https://source.unsplash.com/800x600/?fashion-and-lifestyle,app",
      },
    ],
    articles: [
      {
        title: "Modern Fashion & Lifestyle tech stack",
        url: "#",
        image:
          "https://source.unsplash.com/800x600/?fashion-and-lifestyle,technology",
      },
    ],
    faqs: [
      {
        q: "Do you offer project management solutions for construction companies?",
        a: "Yes, we create tailored project management platforms for contractors and developers.",
      },
      {
        q: "Does your software integrate with existing ERP or accounting systems?",
        a: "Yes, our solutions integrate perfectly with ERP, CRM, and other tools.",
      },
      {
        q: "Do you create apps for on-site construction teams?",
        a: "Yes. We develop mobile applications for reporting, task management, and site safety.",
      },
    ],
    thumb1: "modern",
    thumb2: "house",
    solutions: [
      { title: "Commerce & OMS", desc: "Catalog, payments, and fulfillment." },
      {
        title: "Clienteling & Loyalty",
        desc: "Personalization and membership.",
      },
      {
        title: "PLM & Forecasting",
        desc: "Design-to-shelf and demand planning.",
      },
    ],
    outcomeTitle: "Construction Outcome",
    outcome: [
      "Streamlined project planning, tracking, and resource management.",

      "Improved collaboration with digital dashboards and mobile-first platforms.",

      "Smarter decision-making with analytics-driven insights and reporting.",

      "Increased revenue with optimized workflows and reduced operational costs.",

      "Wider reach in Alwar through SEO-friendly construction websites and platforms.",

      "Stronger construction brand identity with professional graphic design and marketing support.",
    ],
    outcomeParagraph: `Partnering with RashTech Info for construction IT solutions in Alwar ensures measurable efficiency and stronger market presence. Our expertise in project management systems, automation tools, and <a href='/graphic-design-services'>graphic design</a> helps construction companies streamline workflows, showcase their projects effectively, and expand their digital footprint. By integrating secure platforms with creative branding strategies, we empower Alwar-based builders and contractors to achieve both operational excellence and long-term growth.`,
  },
];

export default industries;
